import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/frames/flags.webm")